"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7059],{

/***/ 62284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37946);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  max-width: 130em;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f1d27b44-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 32980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37946);
/* harmony import */ var components_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62284);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52681);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13274);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 10rem;\n  padding-bottom: 4rem;\n  background: #FBF9ED;\n  color: ",
        ";\n  box-shadow: 0px 0px 0px #d3d3d3, 0px -1px 6px #d3d3d3;  \n  color:  #174F68;\n\n  h3 {\n    text-align: center;\n    margin-top: 5px;\n  }\n\n  .mobile-copyright {\n    display: none;\n  }\n\n  @media (max-width: 478px) {\n    h3 {\n      margin-top: 15px;\n    }\n    \n    .mobile-copyright {\n      display: inline-block;\n      font-family: 'Nunito';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 150%;\n      margin-left: 85px;\n      }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n\n  p {\n    margin-top: 3rem;\n    font-family: 'Nunito';\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n\n  }\n\n  img {\n    width: 90%;\n  }\n\n  @media (max-width: 600px) {\n    img {\n      margin-top: -5rem;\n      margin-bottom: 4rem;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  @media (max-width: 478px) {\n    p {\n      display: none;\n    }\n  }\n\n  p {\n    font-size: 14px !important;\n  }\n\n  @media (max-width: 820px) {\n    .mobile-copyright {\n      display: block;\n    }\n    .web-copyright {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img {\n    width: 100%;\n    height: 85%;\n  }\n  \n  @media (max-width: 600px) {\n    \n    img {\n      margin-top: -5rem;\n      margin-bottom: 4rem;\n      width: 90%;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: bold;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 4rem;\n  margin-right: 5rem;\n\n  & > *:not(:first-child) {\n    margin-top: 1rem;\n  }\n  ",
        " {\n    flex: 40%;\n    margin-right: 1.5rem;\n  }\n  ",
        " {\n    margin-left: 6rem;\n    flex: 50% 50%;\n    margin-right: 0rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 1.6rem;\n  \n  a {\n    text-decoration: none;\n    \n    color: #174F68;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img {  \n    width: 120px; \n    object-fit: contain;\n    padding-bottom: 1.5rem;\n  }\n  @media (max-width: 600px) {\n    img {\n      margin-bottom: 70px;\n    }\n    flex-direction: column;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    padding: 5rem;\n    flex-wrap: wrap;\n\n    width: 100%;\n    & > *:not(:first-child) {\n      margin-left: 1rem;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin-top: 2rem;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #174F68;\n\n  @media (max-width: 478px) {\n    font-size: 12px;\n    margin-top: 1rem;\n    display: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  text-align: center;\n  margin-top: 2rem;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #174F68;\n\n  @media (max-width: 478px) {\n    font-size: 12px;\n    margin-top: 1rem;\n    display: block;\n    \n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}







var footerItems = [
    {
        title: "Como funciona",
        items: [
            {
                title: "Perguntas frequentes",
                href: "/faq"
            }
        ]
    },
    {
        title: "Contato",
        items: [
            {
                title: "Fale conosco",
                href: "/contact"
            }
        ]
    },
    {
        title: "Institucional",
        items: [
            {
                title: "Sobre n\xf3s",
                href: "/explore"
            },
            {
                title: "Termos de uso",
                href: "/termos-e-condicoes"
            },
            {
                title: "Pol\xedtica de privacidade",
                href: "/privacy-policy"
            }
        ]
    },
    {
        title: "Redes",
        items: [
            {
                title: "Instagram",
                href: "https://www.instagram.com/nossavaquinha/"
            }, 
        ]
    }, 
];
function Footer() {
    var user = (0,contexts_AuthContext__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .a)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pathUrl = router.asPath;
    var isLogado = user.id && pathUrl !== "/" && pathUrl !== "/blog" && pathUrl !== "/about" && pathUrl !== "/faq" && pathUrl !== "/contact" ? true : false;
    var date = new Date();
    var year = date.getFullYear();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FooterWrapper, {
        colorTheme: "#4397c3",
        isLogado: isLogado,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListContainer, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Logo, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        src: "/Logo.svg",
                                        alt: "Selo Google",
                                        className: "google"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: "web-copyright",
                                        children: [
                                            "\xa9 ",
                                            year,
                                            " - Todos os direitos reservados."
                                        ]
                                    })
                                ]
                            }),
                            footerItems.map(function(singleItem) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterList, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, singleItem), singleItem.title);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Pag, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PaymentStickers, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            src: "/selos-pagamento/selo-google.svg",
                                            alt: "Selo Google",
                                            className: "google"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            src: "/selos-pagamento/selo-pagarme.svg",
                                            alt: "Selo Pagarme",
                                            className: "pagarme"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            src: "/selos-pagamento/ssl.svg",
                                            alt: "Selo SSL",
                                            className: "ssl"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LegalInfo, {
                        children: [
                            "Meu Nascimento Empreendimentos Ltda.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "CNPJ: 48.928.262/0001-47",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "Rua Jos\xe9 Versolato, 111 - S. Bernardo do Campo - SP"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MobileLegalInfo, {
                children: [
                    "Meu Nascimento Empreendimentos Ltda.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "CNPJ: 48.928.262/0001-47",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "Rua Jos\xe9 Versolato, 111 - S. Bernardo do Campo - SP"
                ]
            })
        ]
    });
}
function FooterList(param) {
    var title = param.title, items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListHeader, {
                children: title
            }),
            items.map(function(singleItem) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, singleItem), singleItem.href);
            })
        ]
    });
}
function ListItem(param) {
    var title = param.title, href = param.href;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().pathname;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItemWrapper, {
        colorTheme: "#4397c3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                href: "https://github.com",
                children: title
            })
        })
    });
}
var FooterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-0"
})(_templateObject(), function(param) {
    var colorTheme = param.colorTheme;
    return colorTheme === "#fff6e8" ? "#4397c3" : "#fff";
});
var ListContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-1"
})(_templateObject1());
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-2"
})(_templateObject2());
var Pag = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-3"
})(_templateObject3());
var ListHeader = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9a017512-4"
})(_templateObject4());
var ListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-5"
})(_templateObject5(), (0,utils_media__WEBPACK_IMPORTED_MODULE_6__/* .media */ .B)("<=tablet"), (0,utils_media__WEBPACK_IMPORTED_MODULE_6__/* .media */ .B)("<=phone"));
var ListItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9a017512-6"
})(_templateObject6());
var PaymentStickers = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-7"
})(_templateObject7());
var LegalInfo = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-8"
})(_templateObject8());
var MobileLegalInfo = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-9"
})(_templateObject9());


/***/ }),

/***/ 18783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ModalInformation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37946);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 758px;\n  width: 100%;\n  background-color: #fff;\n  border-radius: 15px;\n  /* padding: 10px; */\n\n  h2 {\n    color: #0076a0;\n    font-family: 'P22 Mackinac Pro';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 120%;\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 25px !important;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 24px !important;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  padding: 5px;\n  left: 0;\n  background-color: #ddd;\n\n  .progress {\n    background-color: #174F68;\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n    padding: 5px;\n    animation: progresso 5s ease-in 1;\n\n    @keyframes progresso {\n      0% {\n        width: 0;\n      }\n      10% {\n        width: 10%;\n      }\n      20% {\n        width: 20%;\n      }\n      30% {\n        width: 30%;\n      }\n      40% {\n        width: 40%;\n      }\n      50% {\n        width: 50%;\n      }\n      60% {\n        width: 60%;\n      }\n      70% {\n        width: 70%;\n      }\n      80% {\n        width: 80%;\n      }\n      90% {\n        width: 90%;\n      }\n      100% {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



function ModalInformation(param) {
    var modalIsOpen = param.modalIsOpen, closeModal = param.closeModal, message = param.message, typeMessage = param.typeMessage, titleMessage = param.titleMessage;
    var handleModal = function() {
        closeModal(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_2___default()), {
        isOpen: modalIsOpen,
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        onRequestClose: handleModal,
        ariaHideApp: false,
        style: {
            overlay: {
                width: "100%",
                zIndex: 9999999,
                margin: "auto"
            },
            content: {
                maxWidth: "758px",
                maxHeight: "200px",
                width: "80%",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                borderRadius: "15px",
                margin: "100px auto",
                padding: "20px"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContainerInformation, {
            children: [
                titleMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleInformationMessage, {
                    typeError: typeMessage,
                    children: titleMessage
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InformationMessage, {
                    typeError: typeMessage,
                    children: message
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ClosingTimeBar, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "progress"
                    })
                })
            ]
        })
    });
}
var ContainerInformation = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7745491b-0"
})(_templateObject());
var TitleInformationMessage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-7745491b-1"
})(_templateObject1(), function(props) {
    return props.typeError === "error" ? "#174F68 !important" : "#174F68 ";
});
var InformationMessage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-7745491b-2"
})(_templateObject2(), function(props) {
    return props.typeError === "error" ? "#174F68 !important" : "#174F68 ";
});
var ClosingTimeBar = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7745491b-3"
})(_templateObject3());


/***/ }),

/***/ 97059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(37946);
// EXTERNAL MODULE: ./contexts/AuthContext.tsx + 1 modules
var AuthContext = __webpack_require__(52681);
// EXTERNAL MODULE: ./env.ts
var env = __webpack_require__(81431);
// EXTERNAL MODULE: ./components/Container.tsx
var Container = __webpack_require__(62284);
// EXTERNAL MODULE: ./components/Footer.tsx
var Footer = __webpack_require__(32980);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./node_modules/@n8tb1t/use-scroll-position/lib/index.js
var lib = __webpack_require__(27714);
;// CONCATENATED MODULE: ./hooks/useScrollPosition.ts

function useScrollPosition(effect, deps, element, useWindow, wait, boundingElement) {
    return (0,lib/* useScrollPosition */.R)(effect, deps, element, useWindow, wait, boundingElement);
}

// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(13274);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/Icon.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background-color: transparent;\n  width: 4rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Icon(_param) {
    var _ref = _param._ref, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "_ref"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, (0,_object_spread/* default */.Z)({
        type: "button"
    }, rest, _ref && {
        ref: _ref
    }));
}
var IconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-51760da4-0"
})(_templateObject());

;// CONCATENATED MODULE: ./components/HamburgerIcon.tsx




function HamburgerIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            stroke: "currentColor",
            fill: "#fff",
            strokeWidth: "0",
            viewBox: "0 0 1024 1024",
            "aria-hidden": "true",
            focusable: "false",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
            })
        })
    }));
}

// EXTERNAL MODULE: ./components/ModalInformation.tsx
var ModalInformation = __webpack_require__(18783);
;// CONCATENATED MODULE: ./public/user-header.png
/* harmony default export */ var user_header = ({"src":"/_next/static/media/user-header.8c4898be.png","height":89,"width":86,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVMaXHq7vAALkqSqbSjuMGPqbJfg5Kqu8PZ4eTi6eobUGkpWm0GQlwhVGo5ZXk4ZHhIbW0XQ1sdVW9Ec4hKd4sp4aEbAAAAEnRSTlMARF6Rp6bfjlhN2zrtvo2QDkign/O/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVR4nBXLRw7AIBAEwSYuSzDWwP/farnuBQQzB7Ar3Qx+5hjzNJL6S1chSWtJhXAjxONgdT/V/tZybvABT5MCE+l5v1cAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Navbar.tsx


function Navbar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  list-style: none;\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    Navbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: auto;\n  text-decoration: none;\n  height: 130%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0.9;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0.5rem;\n  line-height: 2;\n\n  font-family: 'Nunito';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 80%;\n\n  :hover {\n    opacity: 0.9;\n    cursor: pointer;\n  }\n\n  span {\n    display: flex;\n    letter-spacing: 0.025em;\n    text-decoration: none;\n    padding: 0.75rem 1.5rem;\n    font-weight: normal;\n    color: #fff6e8;\n    white-space: nowrap;\n  }\n\n  /*&:not(:last-child) {\n    margin-right: 2rem;\n  }*/\n\n  :last-child {\n    background-color: #174F68;\n    color: #f5f5f5;\n\n    span {\n      color: #f5f5f5;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: sticky;\n  top: 0;\n  padding: 1.5rem 0;\n  width: 100%;\n  height: 7rem;\n  z-index: var(--z-navbar);\n  background: #FBF9ED;\n  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.2);\n  visibility: ",
        ";\n  transform: ",
        ";\n  transition-property: transform, visibility, height, box-shadow, background-color;\n  transition-duration: 0.15s;\n  transition-timing-function: ease-in-out;\n\n  /* @media (max-width: 500px) {\n    height: 10rem;  \n  } */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 5px 30px;\n  background-color: #174F68;\n\n  h3 {\n    color: #fff;\n    font-size: 16px;\n  }\n\n  .resendEmail {\n    border-bottom: 2px solid #fff;\n    padding: 0px 4px;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 280px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  position: absolute;\n  top: 35px;\n  right: 132px;\n  align-self: center;\n  border-radius: 8px;\n  text-decoration: none;\n  z-index: 99999999;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  span {\n    cursor: pointer;\n    font-size: 16px;\n    color: '#174F68';\n    margin-left: 10px;\n\n    a {\n      text-decoration: none;\n      font-style: none;\n      color: '#174F68';\n    }\n  }\n  @media (max-width: 478px) {\n    /* display: none; */\n    right: 0px;\n    top: 60px;\n    width: 92vw;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  justify-content: center;\n  width: 100px;\n  transition: all 0.5s ease-out;\n\n  @keyframes showDropmenu {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  img {\n    cursor: pointer;\n  }\n\n  @media (max-width: 478px) {\n    width: 80px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 7px 2px;\n  cursor: pointer;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid #174F68;\n  }\n\n  & a,\n  & a:link,\n  & a:visited,\n  span {\n    color: #174F68 !important;\n  }\n\n  @media (max-width: 478px) {\n    span {\n      text-decoration: none;\n    }\n\n    .createdEvent {\n      span {\n        color: #fff;\n      }\n    }\n  }\n\n  img {\n    width: 25px;\n    height: 25px;\n  }\n\n  span {\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50px;\n  z-index: 99999;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  right: ",
        ";\n  width: ",
        ";\n  height: 100vh;\n  background-color: #fff6e8;\n  padding: 10px;\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);\n  visibility: ",
        ";\n  transform: ",
        ";\n  transition-property: transform, visibility, height, box-shadow, background-color;\n  transition-duration: 0.15s;\n  transition-timing-function: ease-in-out;\n\n  a {\n    margin: 30px 0px 5px 80px;\n    text-align: left;\n    text-decoration: none;\n    font-size: 3rem;\n    color: #174F68;\n\n    ::hover {\n      color: #000;\n      border-bottom: 1px solid #000;\n    }\n  }\n\n  text-align: center;\n  font-size: 4rem;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}















function Navbar(param) {
    var items = param.items;
    var scrollPositionCallback = function scrollPositionCallback(param) {
        var currPos = param.currPos;
        var routerPath = router.asPath;
        var hasRouteChanged = routerPath !== lastRoute.current;
        if (hasRouteChanged) {
            lastRoute.current = routerPath;
            setScrollingDirection("none");
            return;
        }
        var currentScrollY = currPos.y;
        var isScrollingUp = currentScrollY > lastScrollY.current;
        var scrollDifference = Math.abs(lastScrollY.current - currentScrollY);
        var hasScrolledWholeStep = scrollDifference >= stepSize.current;
        var isInNonCollapsibleArea = lastScrollY.current > -50;
        if (isInNonCollapsibleArea) {
            setScrollingDirection("none");
            lastScrollY.current = currentScrollY;
            return;
        }
        if (!hasScrolledWholeStep) {
            lastScrollY.current = currentScrollY;
            return;
        }
        setScrollingDirection(isScrollingUp ? "up" : "down");
        lastScrollY.current = currentScrollY;
    };
    var router = (0,next_router.useRouter)();
    var pathname = (0,next_router.useRouter)().pathname;
    var ref = (0,react.useState)("none"), scrollingDirection = ref[0], setScrollingDirection = ref[1];
    var ref1 = (0,AuthContext/* useAuth */.a)(), user = ref1.user, signOut = ref1.signOut;
    var ref2 = (0,react.useState)(), showDropMenu = ref2[0], setShowDropMenu = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenDraweMenu = ref3[0], setIsOpenDrawerMenu = ref3[1];
    var ref4 = (0,react.useState)(0), setSizePage = ref4[1];
    var pathUrl = router.asPath;
    var ref5 = (0,react.useState)(""), temaNavbar = ref5[0], setTemaNavbar = ref5[1];
    var ref6 = (0,AuthContext/* useAuth */.a)(), isConfirmedEmail = ref6.isConfirmedEmail, resendEmail = ref6.resendEmail, isResendEmailSucess = ref6.isResendEmailSucess, setIsResendEmailSucess = ref6.setIsResendEmailSucess;
    var isProfileUserPage = pathUrl === "/profile/user";
    var lastScrollY = (0,react.useRef)(0);
    var lastRoute = (0,react.useRef)("");
    var stepSize = (0,react.useRef)(50);
    var isLogado = user.id && pathUrl !== "/about" && pathUrl !== "/faq" && pathUrl !== "/contact" ? true : false;
    var handleResize = function(e) {
        setSizePage(window.innerWidth);
    };
    (0,react.useEffect)(function() {
        setSizePage(window.innerWidth);
        window.addEventListener("resize", handleResize);
    }, []);
    useScrollPosition(scrollPositionCallback, [
        router.asPath
    ], undefined, undefined, 50);
    var isNavbarHidden = scrollingDirection === "down";
    var isTransparent = scrollingDirection === "none";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarContainer, {
                hidden: isNavbarHidden,
                colorTheme: temaNavbar,
                transparent: isTransparent,
                isLogado: isLogado,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInformation/* ModalInformation */.L, {
                            modalIsOpen: isResendEmailSucess,
                            closeModal: setIsResendEmailSucess,
                            message: "Um email de confirma\xe7\xe3o foi enviado com sucesso!",
                            typeMessage: "sucess",
                            titleMessage: "Email enviado com sucesso!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: isLogado ? "/Logo.svg" : "/Logo.svg",
                                    alt: "Logo",
                                    "aria-label": "Ir para a p\xe1gina inicial"
                                })
                            })
                        }),
                        items ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemList, {
                            children: items.map(function(singleItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, (0,_object_spread/* default */.Z)({}, singleItem), singleItem.href);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerMenu, {
                            style: {
                                marginLeft: "8rem"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hoover, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: user_header,
                                        height: 48,
                                        width: 48,
                                        alt: "Logo",
                                        onClick: function() {
                                            return setShowDropMenu(!showDropMenu);
                                        }
                                    })
                                }),
                                showDropMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerDropMenu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineInfo, {
                                            onClick: function() {
                                                return setShowDropMenu(!showDropMenu);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/user.svg",
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/profile/user",
                                                        passHref: true,
                                                        children: user.name
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineInfo, {
                                            onClick: function() {
                                                return setShowDropMenu(!showDropMenu);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdAddCircleOutline */.f8n, {
                                                    size: 27,
                                                    fill: "#174F68"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/pool",
                                                        passHref: true,
                                                        children: "Criar nova vaquinha"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineInfo, {
                                            onClick: function() {
                                                return setShowDropMenu(!showDropMenu);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/porquinho.svg",
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/meus-eventos",
                                                        passHref: true,
                                                        children: "Minhas Campanhas"
                                                    })
                                                })
                                            ]
                                        }),
                                        user.id && pathUrl !== "/profile/user" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                        (user === null || user === void 0 ? void 0 : user.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineInfo, {
                                            onClick: function() {
                                                signOut();
                                                setShowDropMenu(!showDropMenu);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdExit */.WrC, {
                                                    size: 27,
                                                    fill: "#174F68"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "#0000EE"
                                                    },
                                                    children: "Sair"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        items && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamburgerMenuWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HamburgerIcon, {
                                    "aria-label": "Toggle menu",
                                    onClick: function() {
                                        return setIsOpenDrawerMenu(!isOpenDraweMenu);
                                    }
                                }),
                                isOpenDraweMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerDropDownMenu, {
                                    isOpen: isOpenDraweMenu,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/about",
                                            children: "Quem somos"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/faq",
                                            children: "Como funciona"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "",
                                            children: "Vaquinha Meu Nascimento"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/contact",
                                            children: "Contato"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/login",
                                            children: "Entrar"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            !isConfirmedEmail && isProfileUserPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertConfirmedEmail, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    children: [
                        "Seu e-mail ainda n\xe3o foi confirmado. Caso necess\xe1rio,",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "resendEmail",
                            onClick: resendEmail,
                            children: "clique aqui"
                        }),
                        " ",
                        "para receber um novo e-mail."
                    ]
                })
            })
        ]
    });
}
function NavItem(param) {
    var href = param.href, title = param.title, outlined = param.outlined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemWrapper, {
        outlined: outlined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: function() {
                    return router_default().push(href);
                },
                children: title
            })
        })
    });
}
var NavItemList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-0"
})(Navbar_templateObject(), (0,media/* media */.B)("<desktop"));
var HamburgerMenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-1"
})(_templateObject1(), (0,media/* media */.B)(">=desktop"));
var LogoWrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b06a719f-2"
})(_templateObject2());
var Hoover = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b06a719f-3"
})(_templateObject3());
var NavItemWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b06a719f-4"
})(_templateObject4());
var NavbarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-5"
})(_templateObject5(), function(p) {
    return p.hidden ? "hidden" : "visible";
}, function(p) {
    return p.hidden ? "translateY(-8rem) translateZ(0) scale(1)" : "translateY(0) translateZ(0) scale(1)";
});
var AlertConfirmedEmail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-6"
})(_templateObject6());
var Content = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-b06a719f-7"
})(_templateObject7());
var ContainerDropMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-8"
})(_templateObject8());
var ContainerMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-9"
})(_templateObject9());
var LineInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-10"
})(_templateObject10());
var ContainerDropDownMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b06a719f-11"
})(_templateObject11(), function(props) {
    return props.isOpen ? "0" : "-250px";
}, function(props) {
    return props.isOpen ? "100vw" : "0";
}, function(p) {
    return !p.isOpen ? "hidden" : "visible";
}, function(p) {
    return p.isOpen ? "translateX(0vw) translateZ(0) scale(1)" : "translateX(-100vw) translateZ(0) scale(1)";
});

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/tb/index.esm.js
var tb_index_esm = __webpack_require__(37106);
;// CONCATENATED MODULE: ./components/SecondNavbar.tsx

function SecondNavbar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: block;\n  top: 0;\n  padding: 1.5rem 0;\n  width: 100%;\n  height: 6rem;\n  z-index: var(--z-navbar);\n  background-color: #fff6e8;\n  border-bottom: 1px solid #174F68;\n"
    ]);
    SecondNavbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SecondNavbar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  div {\n    :hover {\n      border-bottom: 2px solid #174F68;\n    }\n  }\n  ul {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 30px;\n    list-style-type: none;\n  }\n  li {\n    margin: 15px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.5rem;\n    color: #174F68;\n    @media (max-device-width: 660px) {\n      top: 20px;\n      display: inline;\n      align-items: center;\n      width: 100px;\n      p {\n        margin-top: 0.5rem;\n        margin-right: 2rem;\n        display: none;\n      }\n      img {\n        margin-top: 1rem;\n        max-width: 100%;\n      }\n    }\n  }\n  img {\n    max-width: 30px;\n    margin-right: 1rem;\n  }\n  ",
        " {\n    img {\n      max-width: 25px;\n    }\n    li {\n      margin-left: 10px;\n    }\n  }\n"
    ]);
    SecondNavbar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










function SecondNavbar() {
    var router = (0,next_router.useRouter)();
    var pathUrl = router.asPath;
    return pathUrl !== "/profile/user" && pathUrl !== "/new-event" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNavbar_NavbarContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNavbar_Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/profile/user",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdHomeFilled */.SHD, {
                                        size: 30,
                                        color: "#174F68",
                                        style: {
                                            marginRight: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Home"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tb_index_esm/* TbChecklist */.WzH, {
                                        size: 30,
                                        color: "#174F68",
                                        style: {
                                            marginRight: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Convidados"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRegEdit */.ffH, {
                                        size: 30,
                                        color: "#174F68",
                                        style: {
                                            marginRight: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Convite"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiShare2 */.PMT, {
                                        color: "#174F68",
                                        size: 30,
                                        style: {
                                            marginRight: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Compartilhar"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineMonetizationOn */.aox, {
                                        size: 30,
                                        color: "#174F68",
                                        style: {
                                            marginRight: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Financeiro"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }) : null;
}
var SecondNavbar_NavbarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe64a3c1-0"
})(SecondNavbar_templateObject());
var SecondNavbar_Content = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-fe64a3c1-1"
})(SecondNavbar_templateObject1(), (0,media/* media */.B)("<=desktop"));

;// CONCATENATED MODULE: ./components/Page.tsx

function Page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-repeat: no-repeat;\n  object-fit: contain;\n  background: #FBF9ED;\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  > img {\n    position: absolute;\n  }\n\n  > .img-0 {\n    top: 260px;\n    z-index: 9999;\n    width: 200px;\n  }\n\n  > .img-1 {\n    right: 0;\n    z-index: 9999;\n    width: 200px;\n    top: 260px;\n  }\n\n  > .img-2 {\n    width: 200px;\n    top: 1500px;\n  }\n\n  > .img-3 {\n    right: 0;\n    width: 200px;\n    top: 1500px;\n  }\n"
    ]);
    Page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Page_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "rem;\n  margin-bottom: 10rem;\n"
    ]);
    Page_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











function Page(param) {
    var title = param.title, image = param.image, description = param.description, margin = param.margin, children = param.children, navbar = param.navbar, _isPublicPage = param.isPublicPage, isPublicPage = _isPublicPage === void 0 ? false : _isPublicPage, containerStyles = param.containerStyles, childrenWrapperStyles = param.childrenWrapperStyles;
    var user = (0,AuthContext/* useAuth */.a)().user;
    var pathname = (0,next_router.useRouter)().pathname;
    var ref = (0,react.useState)([]), enfeite = ref[0], setEnfeite = ref[1];
    var ref1 = (0,react.useState)(false), isAuthenticated = ref1[0], setIsAuthenticated = ref1[1];
    var ref2 = (0,react.useState)(false), showSecondNavBar = ref2[0], setShowSecondNavBar = ref2[1];
    var pagesPublic = (0,react.useMemo)(function() {
        return [
            "/pricing",
            "/contact",
            "/cookies-policy",
            "/features",
            "/privacy-policy",
            "/reset-password",
            "/change-password",
            "/faq",
            "/about",
            "/blog",
            "/instrucoes-formulario-recebimento", 
        ];
    }, []);
    var navItems = [
        {
            title: "Criar campanha",
            href: !isAuthenticated ? "/login" : "/profile/user",
            outlined: true
        }, 
    ];
    (0,react.useEffect)(function() {
        setIsAuthenticated(!!(user === null || user === void 0 ? void 0 : user.email));
        setShowSecondNavBar(!pagesPublic.includes(pathname));
    }, [
        isAuthenticated,
        pagesPublic,
        pathname,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            title,
                            " | ",
                            env/* EnvVars.SITE_NAME */.$.SITE_NAME
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "image",
                        content: image
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    (!isAuthenticated || isPublicPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                        items: navItems
                    }),
                    isAuthenticated && !isPublicPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                                items: undefined
                            }),
                            !showSecondNavBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNavbar, {})
                        ]
                    }),
                    enfeite === null || enfeite === void 0 ? void 0 : enfeite.map(function(i, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: i.src,
                                className: "img-".concat(index),
                                alt: "Enfeite"
                            }, index)
                        });
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        style: containerStyles,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenWrapper, {
                            style: childrenWrapperStyles,
                            margin: margin,
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a3e927-0"
})(Page_templateObject());
var ChildrenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a3e927-1"
})(Page_templateObject1(), function(param) {
    var margin = param.margin;
    return margin ? 10 : 0;
});


/***/ })

}]);